import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FormDialogTemplate } from '../../../shared/form-dialog/form-dialog.template';
import { utilities } from '../../../../modules/utility';
import { FilterableService } from '../../mesc/filterable-service';

@Injectable()
export class RequestService {

  formDialog: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  gridTemplate: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  isRequestViewAll: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isToolingFormValid: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private readonly requestNumberService: FilterableService = new FilterableService();
  private readonly processService: FilterableService = new FilterableService();
  private readonly originatorService: FilterableService = new FilterableService();
  private readonly requestStatusService: FilterableService = new FilterableService();
  private readonly modifiedByService: FilterableService = new FilterableService();

  lookupData = {
    RequestNumber: this.requestNumberService,
    ProcessName: this.processService,
    OriginatorName: this.originatorService,
    RequestStatus: this.requestStatusService,
    ModifiedBy: this.modifiedByService
  }

  private readonly dialogStack: FormDialogTemplate[] = [];
  constructor() { }

  openDialog(template: FormDialogTemplate) {
    if (template) this.dialogStack.push(template);
    this.formDialog.next(template);
  }

  closeDialog() {
    this.dialogStack.pop();
    this.openDialog(this.dialogStack.pop());
  }

  getViewState = (): boolean => this.isRequestViewAll.value;
  setViewState = (state: boolean) => this.isRequestViewAll.next(state);


  /**
   * 
   */
  mapRequestDates = (requests: any[]): any[] => {
    return requests.map(r => {
      r.ModifiedDate = utilities.getLocalDateTime(r.ModifiedDate);
      r.SubmissionDate = utilities.getLocalDateTime(r.SubmissionDate);
      return r;
    });
  }


  /**
   * 
   * @param data 
   */
  setLookupData(data) {
    if (data) {
      this.requestNumberService.next(data.RequestNumber);
      this.processService.next(data.ProcessName);
      this.originatorService.next(data.OriginatorName);
      this.requestStatusService.next(data.RequestStatus);
      this.modifiedByService.next(data.ModifiedBy);
    } else {
      this.requestNumberService.next([]);
      this.processService.next([]);
      this.originatorService.next([]);
      this.requestStatusService.next([]);
      this.modifiedByService.next([]);
    }
  }
}
